import Vue from 'vue'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import store from './store/store'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/index'

Vue.config.productionTip = false

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const optionsToast = {
    transition: "Vue-Toastification__bounce",
    maxToasts: 3,
    newestOnTop: true,
    position: "bottom-center",
    timeout: 2000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: false,
    draggable: true,
    draggablePercent: 0.7,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
};

import readCookie from './plugins/baseplugins'
import readCookiePlugin from './plugins/baseplugins'

import BaseConformSave from "@/components/BaseConformSave";

Vue.component('BaseConformSave', BaseConformSave)
import BaseSheet from "@/components/BaseSheet"

Vue.component('BaseSheet', BaseSheet)
import BaseComparableTextField from "@/components/BaseComparableTextField"

Vue.component('BaseComparableTextField', BaseComparableTextField)


import BaseBoolIndicator from "@/components/BaseBoolIndicator";
Vue.component('BaseBoolIndicator', BaseBoolIndicator)

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

Vue.use(Toast, optionsToast);

Vue.use(VueMaterial)
Vue.use(Vuetify)
Vue.use(readCookie)

import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

import VueMoment from 'vue-moment'
import BaseTextField from "@/components/BaseComparableTextField";

Vue.use(VueMoment)


import {TiptapVuetifyPlugin} from "tiptap-vuetify";

// don't forget to import styles
import "tiptap-vuetify/dist/main.css";

import i18n from './i18n'
// import FlagIcon from 'vue-flag-icon'
// Vue.use(FlagIcon)

const vuetifyLang = new Vuetify({
    lang: {
        // If you change the language here, then it changes in the editor itself
        current: "en" // en | es | fr | pl | ru
    }
});

// you don't need it. this is for example purposes
// const iconsGroup = localStorage.getItem("current_icons_group") || "fa";
const iconsGroup = "mdi";

Vue.use(TiptapVuetifyPlugin, {
    vuetify: vuetifyLang,
    // "md" (default), "fa", "mdi"
    iconsGroup // same as "iconsGroup: iconsGroup"
});

//
// import VModal from 'vue-js-modal'
// Vue.use(VModal)

import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

import {createPinia, PiniaVuePlugin} from 'pinia'
Vue.use(PiniaVuePlugin)
let pinia = createPinia()

new Vue({
    router,
    store: store,
    vuetify,
    i18n,
    // FlagIcon,
    VuePapaParse,
    pinia,
    render: h => h(App)
}).$mount('#app')
